export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9554.48dc328a.jpg";